import React from 'react';
import { AppRouter } from '../../routes/StripedRouter/StripedRouter';
import ErrorBoundary from '../ErrorBoundary';

const App = () => (
  <ErrorBoundary>
    <AppRouter />
  </ErrorBoundary>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js